import { Injectable } from '@angular/core'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { AutomationViewGroup } from '@tokeet-frontend/automations'
import { AutomationLogsDialogComponent } from '@tv3/containers/automations/automation-logs/dialog/automation-logs-dialog.component'

@Injectable()
export class AutomationLogsDialogService {
  constructor(private dialog: DialogService) {}

  open(automationGroup: AutomationViewGroup) {
    this.dialog.openDrawer(AutomationLogsDialogComponent, {
      panelClass: 'drawer-full-80',
      data: { automationGroup },
    })
  }
}
